/**
 * Mobile Navigation Menu.
 *
 * Hamburger icon on the RHS of navigation bar.
 * When tapped/clicked, it opens a full screen
 * menu below the navbar and the hamburger is
 * replaced with -out icon. Clicking x-out icon
 * closes the menu.
 *
 * User of the class is expected to provide
 * the menu items.
 */

import React, { Component } from 'react';
import { slide as Menu } from 'react-burger-menu';

/**
 * Mobile Navigation Menu.
 */
export class MobileNavigation extends Component {
  state = { menuOpen: false };

  closeMobileMenu = () => {
    this.setState({ menuOpen: false });
  };

  handleStateChange = state => {
    const { onToggle = () => {} } = this.props;
    if (onToggle) {
      onToggle(state.isOpen);
    }
    this.setState({ menuOpen: state.isOpen });
  };

  isCollection = (obj) => {
    // Don't want to use Array.isArray here because it is a collection not an array
    return !!obj.length;
  };

  addTouchHandlerToBurgerMenu = () => {
    // This is a workaround for iOS 12, the studio overlaying the menu on mobile...
    // ... and the use of a library for the burger menu
    // Forwards the onTouch event as an onClick to the bm button - only onClick is handled in the library
    const renderedMenus = document.getElementsByClassName('bm-burger-button');
    const burgerMenu = this.isCollection(renderedMenus) && renderedMenus[0];

    const bmButton = burgerMenu.childNodes &&
    this.isCollection(burgerMenu.childNodes) &&
    burgerMenu.childNodes.length > 1 &&
    burgerMenu.childNodes[1];

    if (bmButton) {
      bmButton.ontouchend = () => {
        bmButton.click();
      };
    }
  };

  componentDidMount = () => {
    this.addTouchHandlerToBurgerMenu();
  };

  render () {
    const { navbarHeight, navItemsMenu } = this.props;

    return (
      <Menu
        right
        isOpen={this.state.menuOpen}
        onStateChange={this.handleStateChange}
        styles={getStyles(navbarHeight, this.state.menuOpen)}
      >
        {
          navItemsMenu && navItemsMenu.map(MenuItem => (
            React.cloneElement(
              MenuItem,
              {onMenuItemClick: this.closeMobileMenu}
            )
          ))
        }
      </Menu>
    );
  }
}

export default MobileNavigation;

/**
 * Styles are dynamically computed based on
 * navbar height and menu open/closed status.
 */
const burgerHeight = 20;
const crossHeight = 24;

const getStyles = (navbarHeight, menuOpen) => ({
  bmBurgerButton: {
    display: menuOpen ? 'none' : 'block',
    position: 'absolute',
    height: `${burgerHeight}px`,
    width: '24px',
    right: '9px',
    top: `${(navbarHeight - burgerHeight) / 2}px`
  },
  bmBurgerBars: {
    background: '#373a47',
    borderRadius: '20px'
  },
  bmCrossButton: {
    background: 'white !important',
    top: `-${7 + (navbarHeight + crossHeight) / 2}px`,
    right: '15px',
    height: `${crossHeight}px`,
    width: '24px'
  },
  bmCross: {
    background: 'black',
    height: '24px',
    opacity: menuOpen ? 1 : 0,
    transition: '.2s',
    transitionDelay: menuOpen ? '.2s' : '0s',
    transitionProperty: 'opacity'
  },
  bmMenu: {
    background: 'white',
    paddingTop: '0',
    fontSize: '16px'
  },
  bmMenuWrap: {
    position: 'absolute',
    height: `calc(100vh - ${navbarHeight - 1}px)`,
    width: '100%',
    minWidth: '300px',
    top: `${navbarHeight - 1}px`
  },
  bmMorphShape: {
    fill: '#373a47'
  },
  bmItemList: {
    color: 'black',
    marginBottom: `${navbarHeight * 4}px`
  },
  bmOverlay: {
    background: 'white'
  }
});
